var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Svg } from './Svg';
var ArrowDropdownDownIcon = function (props) { return (React.createElement(Svg, __assign({}, props),
    React.createElement("g", null,
        React.createElement("path", { d: "M2.41421356,7 L21.5857864,7 C22.1380712,7 22.5857864,7.44771525 22.5857864,8 C22.5857864,8.26521649 22.4804296,8.5195704 22.2928932,8.70710678 L12.8485281,18.1514719 C12.379899,18.620101 11.620101,18.620101 11.1514719,18.1514719 L1.70710678,8.70710678 C1.31658249,8.31658249 1.31658249,7.68341751 1.70710678,7.29289322 C1.89464316,7.10535684 2.14899707,7 2.41421356,7 Z", transform: "translate(12.000000, 13.000000) scale(-1, 1) translate(-12.000000, -13.000000)" })))); };
export var ArrowDropdownDown = styled(ArrowDropdownDownIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
//# sourceMappingURL=ArrowDropdownDown.js.map